export default "__VITE_ASSET__CeRk0KCx__"